import axios from "axios";

const postPhoto = async (photo) => {
  return await axios.post(window.url_api + "/photo", photo);
};

const putPhoto = async (name, photo) => {
  return await axios.put(window.url_api + "/photo/" + name, photo);
};

const getPhoto = async (name) => {
  return await axios.get(window.url_api + "/photo/" + name);
};

const getLocalizacao = async (position) => {
  return await axios.get(
    `https://geocode.xyz/${position.coords.latitude},${position.coords.longitude}?json=1`
  );
};

export default {
  postPhoto,
  putPhoto,
  getPhoto,
  getLocalizacao,
};
